import {Rect, Transformer} from "react-konva";
import React, {useState, useEffect, useRef} from "react";
import PropTypes from 'prop-types';

const BoundingBoxComponent = ({
                                  xOffset,
                                  yOffset,
                                  imageWidth,
                                  imageHeight,
                                  selectedWordBbox,
                                  addOrUpdatePages,
                                  pageNumber

                              }) => {
    const boundingBoxRef = useRef();
    const transformerRef = useRef();
    const [boundingBox, setBoundingBox] = useState(null);

    function getRectangleCoordinates(rect) {
        const x1 = rect.x;
        const y1 = rect.y;
        const x3 = rect.x + rect.width;
        const y3 = rect.y + rect.height;

        return [x1, y1, x3, y3];
    }

    const updateWords = (boundingBoxShape) => {
        let newVertices = selectedWordBbox?.vertices
        newVertices.lines[selectedWordBbox.lineIndex].words[selectedWordBbox.wordIndex].bbox = boundingBoxShape
        addOrUpdatePages(pageNumber, JSON.stringify(newVertices), 'vertices');
    }

    useEffect(() => {
        if (selectedWordBbox?.word?.bbox) {
            const wordBox = selectedWordBbox.word.bbox
            setBoundingBox({
                x: wordBox[0],
                y: wordBox[1],
                width: wordBox[2] - wordBox[0],
                height: wordBox[3] - wordBox[1],
            });
        } else {
            setBoundingBox(null)
        }
    }, [selectedWordBbox]);

    useEffect(() => {
        if (boundingBoxRef.current && transformerRef.current) {
            transformerRef.current.nodes([boundingBoxRef.current]);
            transformerRef.current.getLayer().batchDraw();
        }
    }, [boundingBox]);

    const handleDragStart = (e) => {
    };

    const handleDragEnd = (e) => {

        const boundingBoxShape = {...boundingBox};
        const newX = e.target.x() - xOffset;
        const newY = e.target.y() - yOffset;

        if (newX >= 0 && newY >= 0 && newX + boundingBoxShape.width <= imageWidth && newY + boundingBoxShape.height <= imageHeight) {
            boundingBoxShape.x = newX;
            boundingBoxShape.y = newY;
            setBoundingBox(boundingBoxShape)
            updateWords(getRectangleCoordinates(boundingBoxShape))

        } else {
            e.target.x(boundingBox.x + xOffset);
            e.target.y(boundingBox.y + yOffset);
        }
    };

    const handleTransform = (e) => {
        const node = boundingBoxRef.current;
        const scaleX = node.scaleX();
        const scaleY = node.scaleY();

        const newWidth = Math.max(node.width() * scaleX, 10);
        const newHeight = Math.max(node.height() * scaleY, 10);

        node.scaleX(1);
        node.scaleY(1);

        let newX = node.x() - xOffset;
        let newY = node.y() - yOffset;

        const withinBounds =
            newX >= 0 &&
            newY >= 0 &&
            newX + newWidth <= imageWidth &&
            newY + newHeight <= imageHeight;

        if (withinBounds) {
            setBoundingBox({
                x: newX,
                y: newY,
                width: newWidth,
                height: newHeight,
            });

            updateWords(getRectangleCoordinates({
                x: newX,
                y: newY,
                width: newWidth,
                height: newHeight,
            }))

        } else {
            node.x(boundingBox.x + xOffset);
            node.y(boundingBox.y + yOffset);
            node.width(boundingBox.width);
            node.height(boundingBox.height);
        }
    };

    return (
        <>
            {boundingBox && (
                <>
                    <Rect
                        x={boundingBox.x + xOffset}
                        y={boundingBox.y + yOffset}
                        width={boundingBox.width}
                        height={boundingBox.height}
                        fill="rgb(32, 143, 213, 0.1)"
                        stroke="rgb(32, 143, 213)"
                        strokeWidth={1}
                        draggable
                        onDragStart={handleDragStart}
                        onDragEnd={handleDragEnd}
                        onTransformEnd={handleTransform}
                        ref={boundingBoxRef}
                    />
                    <Transformer
                        ref={transformerRef}
                        resizeEnabled={true}
                        rotateEnabled={false}
                    />
                </>
            )}
        </>
    );
};


BoundingBoxComponent.propTypes = {
    xOffset: PropTypes.number.isRequired,
    yOffset: PropTypes.number.isRequired,
    imageWidth: PropTypes.number.isRequired,
    imageHeight: PropTypes.number.isRequired,
    zoom: PropTypes.number,
    selectedWordBbox: PropTypes.array,
    addOrUpdatePages: PropTypes.func.isRequired,
    pageNumber: PropTypes.number,
};

export default BoundingBoxComponent;
